import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { SafeHtml, DomSanitizer } from "@angular/platform-browser";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { DatePipe } from "@angular/common";
import { Medium24Pipe } from "../../../../../../../shared/src/lib/pipe/medium-24.pipe";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

@Component({
    selector: "app-market-rules",
    imports: [MatIconModule, MatButtonModule],
    providers: [DatePipe, Medium24Pipe],
    templateUrl: "./market-rules.component.html",
    styleUrls: ["./market-rules.component.scss"]
})
export class MarketRulesComponent implements OnInit {
  safeHtmlContent: SafeHtml = "";

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public bottomSheetRef: MatBottomSheetRef,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    const content = this.generateContent(this.data?.description?.rules || "");
    const header = this.generateHeader(
      this.data?.marketName,
      this.data?.marketStartTime,
    );
    this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(
      header + content,
    );
  }

  private generateContent(content: string): string {
    if (content.includes("_Local_Time_")) {
      const currentDate =
        this.datePipe.transform(new Date(), "MMM d, y, HH:mm:ss a") || "";
      return content.replace("_Local_Time_", currentDate);
    }
    if (content.includes("in-play")) {
      return content.replace("in-play", `<b>IN PLAY</b>`);
    }
    return content;
  }

  private generateHeader(
    marketName: string = "",
    marketStartTime: string = "",
  ): string {
    const format = "EEE, dd MMM yyyy HH:mm:ss";
    const utcStartTime = this.formatUtcTime(marketStartTime, format);
    const localStartTime = this.formatLocalTime(marketStartTime, format);
    return `
      <div>
        <span style="font-size: 25px;">${marketName} - Rules</span>
        <hr />
        <br />
        <b>Event Start Time</b>
        <div>
          <span>${utcStartTime} (UTC)</span><br />
          <span>${localStartTime} (Your local time)</span>
        </div>
        <br />
        <b>Win only market</b>
        <br />
      </div>
    `;
  }

  private formatUtcTime(date: string, dateFormat: string): string {
    const utcDate = toZonedTime(date, "UTC");
    return format(utcDate, dateFormat);
  }

  private formatLocalTime(date: string, dateFormat: string): string {
    const localDate = new Date(date);
    return format(localDate, dateFormat);
  }
}
